import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, SvgIcon, TextField } from '@mui/material';
import React, { ReactNode, useState } from 'react';
import errorIcon from '../assets/alert-error.svg';

interface IProps {
  title?: string;
  message: string | ReactNode;
  showDialog: boolean;
  confirmed: (confirm: boolean, input?: string) => void;
  isVerifiableInput?: boolean;
  btnCancel?: string;
  btnConfirm?: string;
  disabled?: boolean;
  alertIcon?: 'error';
}

// TODO: add other alert icons as required, e.g. 'warning', 'info', etc.

export function ConfirmDialog(props: IProps) {
  const { title, message, showDialog, confirmed, btnCancel, btnConfirm, isVerifiableInput, disabled, alertIcon } = props;
  const [verifiableInput, setVerifiableInput] = useState<string>('');

  const disableBtns = disabled || false;

  const getIcon = () => {
    if (alertIcon) {
      switch (alertIcon) {
        case 'error':
          return errorIcon;
        default:
          console.warn(`Alert icon "${alertIcon}" is not supported.`);
          return errorIcon; // Default icon if none specified
      }
    }
  };

  return (
    <Dialog disableEnforceFocus open={showDialog} onClose={(event, reason) => reason !== 'backdropClick' && confirmed}>
      {title && <DialogTitle>{title}</DialogTitle>}
      {alertIcon && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Box component="img" src={getIcon()} />
        </Box>
      )}
      <DialogContent>
        {typeof message === 'string' ? <DialogContentText>{message}</DialogContentText> : message}
        {isVerifiableInput && (
          <TextField
            autoFocus
            margin="dense"
            id="verifiableInput"
            data-test="confirm-dialog-input"
            type="text"
            fullWidth
            onChange={(event) => setVerifiableInput(event.target.value)}
            variant="standard"
            value={verifiableInput}
          />
        )}
      </DialogContent>

      <DialogActions>
        {btnCancel && (
          <Button onClick={() => confirmed(false, verifiableInput)} color="primary" disabled={disableBtns}>
            {btnCancel}
          </Button>
        )}
        {btnConfirm && (
          <Button
            onClick={() => confirmed(true, verifiableInput)}
            color="primary"
            disabled={disableBtns}
            data-test="button-confirm-dialog-ok"
          >
            {btnConfirm}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
